import LegalLayout, { LegalSection } from "@/components/site/LegalLayout";

export default function TermsConditions() {
  return (
    <LegalLayout
      testid="terms-conditions-page"
      eyebrow="Legal"
      title={<>Terms &amp;<br />Conditions</>}
      updated="July 1, 2026"
    >
      <LegalSection title="1. Acceptance of Terms" testid="terms-section-acceptance">
        <p>
          These Terms &amp; Conditions ("Terms") govern your use of the UCUBE Technologies
          website and any services described on it. By accessing this website, you agree to be
          bound by these Terms. If you do not agree, please do not use this website.
        </p>
      </LegalSection>

      <LegalSection title="2. Use of This Website" testid="terms-section-use">
        <ul>
          <li>You agree to use this website only for lawful purposes.</li>
          <li>You will not attempt to disrupt, damage, or gain unauthorised access to this website or its systems.</li>
          <li>You will not submit false, misleading, or fraudulent information through our forms.</li>
        </ul>
      </LegalSection>

      <LegalSection title="3. Intellectual Property" testid="terms-section-ip">
        <p>
          All content on this website — including text, graphics, logos, and design — is the
          property of UCUBE Technologies or its licensors and is protected by applicable
          intellectual property laws. You may not reproduce, distribute, or create derivative
          works from this content without our prior written consent.
        </p>
      </LegalSection>

      <LegalSection title="4. Services & Engagements" testid="terms-section-services">
        <p>
          Descriptions of services on this website are for informational purposes only and do
          not constitute a binding offer. Any actual engagement with UCUBE Technologies is
          governed by a separate signed agreement between UCUBE Technologies and the client,
          which will set out scope, pricing, timelines, and deliverables.
        </p>
      </LegalSection>

      <LegalSection title="5. No Warranties" testid="terms-section-warranties">
        <p>
          This website and its content are provided "as is" without warranties of any kind,
          express or implied. We do not guarantee that the website will be uninterrupted, error
          free, or free of harmful components.
        </p>
      </LegalSection>

      <LegalSection title="6. Limitation of Liability" testid="terms-section-liability">
        <p>
          To the fullest extent permitted by law, UCUBE Technologies shall not be liable for any
          indirect, incidental, or consequential damages arising from your use of this website.
        </p>
      </LegalSection>

      <LegalSection title="7. Third-Party Links" testid="terms-section-links">
        <p>
          This website may contain links to third-party websites. We are not responsible for the
          content, accuracy, or practices of any linked third-party site.
        </p>
      </LegalSection>

      <LegalSection title="8. Governing Law" testid="terms-section-law">
        <p>
          These Terms are governed by the laws of India, without regard to conflict of law
          principles. Any disputes shall be subject to the exclusive jurisdiction of the courts
          in Pune, Maharashtra.
        </p>
      </LegalSection>

      <LegalSection title="9. Changes to These Terms" testid="terms-section-changes">
        <p>
          We may update these Terms from time to time. Continued use of this website after
          changes are posted constitutes acceptance of the revised Terms.
        </p>
      </LegalSection>

      <LegalSection title="10. Contact Us" testid="terms-section-contact">
        <p>
          Questions about these Terms can be sent to{" "}
          <a href="mailto:contactus@ucubetechnologies.com">contactus@ucubetechnologies.com</a>.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
